export const WORK_PLAN = '/work-plan' as const
export const WORK_PLAN_CREATED = `${WORK_PLAN}/created` as const
export const WORK_PLAN_ASSIGNED = `${WORK_PLAN}/assigned` as const
